const sortToGtmString = (sort: number) => {
  switch (sort) {
    case 1:
      return 'default'; // popularity
    case 2:
      return 'best-seller';
    case 3:
      return 'new';
    default:
      return 'default';
  }
};

export const gtmChangeSortingEvent = (sort: number) => ({
  event: 'sorting-option-change',
  'sorting-option': sortToGtmString(sort),
});

export const gtmSortSelectEvent = (sort: number) => ({
  event: 'sort_select',
  sort_by: sortToGtmString(sort),
});

export default gtmChangeSortingEvent;
